import { useEffect } from 'react';

const Page404 = () => {

  useEffect(() => {
    document.getElementsByClassName('ui-loader-container')[0]?.remove();
  }, []);

  return (
    <div className="page-container">
      <div className="centered-content">
        <div className="ollama-logo sad">😢</div>
        <h1 className="error-title">404</h1>
        <h2 className="error-subtitle">Page Not Found</h2>
        <div className="error-description">
          Oops! The page you're looking for seems to have wandered off. 
          Even our llama couldn't find it!
        </div>
        <button className="home-btn" onClick={() => window.location.href = '/'}>
          Go Home
        </button>
      </div>
    </div>
  );
};

export default Page404;